import axios from '@/util/request'

const baseURL = process.env.VUE_APP_API_URL

export default {
  // 店铺页面
  signIn: data => {
    return new Promise((resolve, reject) => {
      axios({ baseURL, url: '/api/store/open/signUp', data, method: 'post' }).then(result => {
        resolve(result)
        window.ttq && window.ttq.track('CompleteRegistration')
        window.rdt && window.rdt('track', 'SignUp')
      }).catch(error => {
        reject(error)
      })
    })
  }, // 注册
  sendQuestionnaireAnswers: params => axios({ baseURL, url: '/api/store/open/questionnaireAnswers', method: 'PUT', params }), // 注册时通过用户ID更新调查问卷
  sendVertificationCode: data => axios({ baseURL, url: '/api/store/open/verificationCode', method: 'POST', data }), // 发送验证码
  checkVerificationCode: data => axios({ baseURL, url: '/api/store/open/checkVerificationCode', method: 'POST', data }), // 验证验证码
  handleForgetPassword: data => axios({ baseURL, url: '/api/store/open/forgetPassword', data, method: 'post' }), // 忘记密码
  handleModifyPassword: data => axios({ baseURL, url: '/api/store/open/password', data, method: 'put' }), // 修改密码
  getUserInfo: userId => axios({ baseURL, url: `/api/store/user/${userId}`, method: 'get' }), // 获取用户信息
  connectNewStore: data => axios({ baseURL, url: '/api/store/shopify/newStore', data, method: 'post' }), // 链接新店
  getStoreList: params => axios({ baseURL, url: `/api/store/storeList`, method: 'get' }), // 获取店铺列表
  getStoreDetail: storeId => axios({ baseURL, url: `/api/store/storeSettingDetail/${storeId}`, method: 'get' }), // 店铺设置详情
  setStore: data => axios({ baseURL, url: '/api/store/storeSetting', data, method: 'post' }), // 设置店铺
  handleReauthorize: storeId => axios({ baseURL, url: `/api/store/reauthorize/${storeId}`, method: 'get' }), // 重新授权
  modefyStoreStatus: data => axios({ baseURL, url: '/api/store/storeStatus', data, method: 'put' }), // 修改店铺状态
  deleteStore: storeId => axios({ baseURL, url: `/api/store/store/${storeId}`, method: 'delete' }), // 删除店铺
  getAddressList: params => axios({ baseURL, url: `/api/store/addressList`, method: 'get', params }), // 地址列表
  editAddress: data => axios({ baseURL, url: '/api/store/address', data, method: 'post' }), // 新增/编辑地址
  deleteAddress: id => axios({ baseURL, url: `/api/store/address/${id}`, method: 'delete' }), // 删除地址
  setDefaultAddress: id => axios({ baseURL, url: `/api/store/defaultAddress/${id}`, method: 'put' }), // 删除地址
  getAddressInfo: params => axios({ baseURL, url: '/api/system/dictValue', method: 'get', params }), // 获取省市州数据
  userBindStore: data => axios({ baseURL, url: '/api/store/storeBind', method: 'POST', data }), // 店铺与用户绑定
  bindWoocommerceStore: data => axios({ baseURL, url: '/api/v1/store/open/woocommerce/auth', method: 'POST', data }), // Woocommerce店铺授权

  systemAddressInfo: params => axios({ baseURL, url: '/api/system/open/address', method: 'get', params }) // 获取地址信息数据字典

}
